import { useState } from 'react'
import { Upload, Button, message } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import { getRequestHeader } from '../@utils/request'
import config from '../@config'
export default function useUpLoadGetProductList({
  actionUrl = '',
  requestData = {},
  onSuccess = null,
  title = '导入',
  beforeUpload = file => Promise.resolve(file)
} = {}) {
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const uploadProps = {
    name: 'file',
    headers: getRequestHeader(),
    multiple: false,
    data: requestData,
    beforeUpload,
    onChange(info) {
      if (info.file.status === 'uploading') setLoading(true)
      if (info.file.status === 'done') {
        setLoading(false)
        const { response } = info.file || {}
        console.log(response, info)
        if (response && response.code === 200) {
          let list = response.data
          if (list && list.length) {
            message.success(`成功导入${list.length}条数据`)
            setList(response.data || [])
          }
          if (onSuccess) onSuccess()
        } else {
          message.error(response.message || '')
        }
      } else if (info.file.status === 'error') {
        setLoading(false)
        message.error(`${info.file.name}上传失败`)
      }
    },
    progress: {
      strokeColor: {
        '0%': '#108ee9',
        '100%': '#87d068'
      },
      strokeWidth: 3,
      format: percent => `${parseFloat(percent.toFixed(2))}%`
    },
    showUploadList: false
  }
  const uploadBtn = (
    <Upload action={config.BASE_API + actionUrl} {...uploadProps}>
      <Button loading={loading} type='primary' icon={<UploadOutlined />}>
        {title}
      </Button>
    </Upload>
  )

  return {
    list,
    uploadBtn,
    setList
  }
}
